//
// Module for the DROP Disbursement Lump Sum wizard's Account Balance step
//
rs.module("participant/benefit/setup/dropdisbursement/lumpsum/wizard/accountbalancestep",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, variables, backendUrls) {

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var totalAddedInterestInput = stepContainer.js(jsSelectors.totalAddedInterestInput, { required: false });
            var totalBalanceAmountContainer = stepContainer.js(jsSelectors.totalBalanceAmountContainer, { required: false });
            var partialTaxableInput = stepContainer.js(jsSelectors.partialTaxableInput, { required: false });
            var partialNonTaxableInput = stepContainer.js(jsSelectors.partialNonTaxableInput, { required: false });
            var partialTotalLabel = stepContainer.js(jsSelectors.partialTotalLabel, { required: false });

            // Hookup totalAddedInterestInput change event
            totalAddedInterestInput.on('input', _.debounce(updateTotalForTotalDisbursement, 400));

            // Hookup partialTaxableInput and partialNonTaxableInput change events
            partialTaxableInput.on('input', _.debounce(updateTotalForPartialDisbursement, 400));
            partialNonTaxableInput.on('input', _.debounce(updateTotalForPartialDisbursement, 400));

            // On initialize, calculate totals (necessary for back/forth wizard navigation)
            if (variables.isPartial) {
                updateTotalForPartialDisbursement()
            }
            else {
                updateTotalForTotalDisbursement()
            }

            // For a total disbursement, update the total if Added Interest is changed
            function updateTotalForTotalDisbursement() {

                var addedInterest = $.getNormalizedCurrencyValue(totalAddedInterestInput.val());

                $.get(
                    backendUrls.getTotalForTotalDisbursement,
                    {
                        balance: variables.accountBalanceAmount,
                        interest: addedInterest
                    },
                    function (data) {
                        totalBalanceAmountContainer.html(data.total);
                    }
                );
            }

            // For a partial disbursement, update the total when Taxable or Non Taxable amount changed
            function updateTotalForPartialDisbursement() {

                var taxableAmount = $.getNormalizedCurrencyValue(partialTaxableInput.val());
                var nonTaxableAmount = $.getNormalizedCurrencyValue(partialNonTaxableInput.val());

                $.get(
                    backendUrls.getTotalForPartialDisbursement,
                    {
                        taxable: taxableAmount,
                        nonTaxable: nonTaxableAmount
                    },
                    function (data) {
                        partialTotalLabel.text(data.total);
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);